import type { Enums } from "@/lib/database.types";

export type Badge = Enums<"book_badge">;
export type Price = Enums<"book_price">;

/** Badge → { bg, fg } colours. Ported from the prototype `badgeColor`. */
export const BADGE_COLORS: Record<Badge, { bg: string; fg: string }> = {
  "Expert-reviewed": { bg: "#E7EDE6", fg: "#29483D" },
  Cited: { bg: "#E7EDE6", fg: "#29483D" },
  Standard: { bg: "#F0EBDD", fg: "#4a4f49" },
  Premium: { bg: "#FCE9D9", fg: "#B86F44" },
  Personal: { bg: "#F0EBDD", fg: "#3d423c" },
  Community: { bg: "#F0EBDD", fg: "#4a4f49" },
  "For fun": { bg: "#FCE9D9", fg: "#B86F44" },
  Workspace: { bg: "#EDE4D3", fg: "#3d423c" },
  Popular: { bg: "#FCE9D9", fg: "#B86F44" },
};

const ROMAN: [number, string][] = [
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"],
];

export function roman(n: number): string {
  let out = "";
  let num = n;
  for (const [value, sym] of ROMAN) {
    while (num >= value) {
      out += sym;
      num -= value;
    }
  }
  return out || "I";
}

export function initialsOf(name: string): string {
  return name
    .split(/[\s.]+/)
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

/** Explore categories (canonical labels from the seed catalogue). */
export const CATEGORIES = [
  "All",
  "Programming",
  "Science",
  "Design",
  "Life",
  "Business",
  "Engineering",
  "Home and Craft",
  "Creativity",
  "Humour",
  "Team Handbooks",
] as const;

export const PRICE_LABEL: Record<Price, string> = {
  free: "Free",
  premium: "Premium",
  private: "Private",
};
